<template>
  <div :class="[baseCss, dark ? `${baseCss}-dark` : null, dark ? 'bg-black' : 'bg-white', 'transition-all', 'duration-300', 'block']">
    <card :rounded="false" bg-color="transparent" :bg-color-lightness="null">
      <card-text :padding-off="true" elevation="none" :style="{width}" :class="[readonly ? 'mb-4' : null]">
        <ul :class="[`${baseCss}-commands-list`, 'overflow-y-auto', 'mt-4', 'mx-4']" :style="{height}">
          <li v-for="(command, index) in history" :key="index" :class="['whitespace-nowrap']">
            <code :style="{color: command.color, background: command.bgColor}">{{ command.prefix }}&nbsp;{{ command.command }}</code>
          </li>
        </ul>
      </card-text>
      <card-actions :padding-off="true" align="left" v-if="!readonly">
        <async-form :form-data="console" @submit="execute" :class="['mx-2', 'mb-2']">
          <table-layout y-align="middle">
            <row>
              <cell>
                <text-field @keyup="onKeyUp" :autofocus="true" :color="uiColor" :color-lightness="uiColorLightness" :icon-left="icon ? 'console' : null" v-model="console.command" />
              </cell>
              <cell v-if="colorPicker">
                <color-picker size="22px" v-model="internalColor" :label="false" />
              </cell>
            </row>
          </table-layout>
        </async-form>
      </card-actions>
    </card>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Terminal',
  mixins: [
    methods
  ],
  data () {
    return {
      console: {
        command: ''
      },
      defaultColors: [
        '#ffffff',
        '#000000'
      ],
      internalColor: '#ffffff',
      textBgColor: null,
      history: [],
      position: 0,
      baseCss: this.componentBaseCss('terminal', [])
    }
  },
  props: {
    dark: {
      type: Boolean,
      default: true
    },
    icon: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    prefix: {
      type: String,
      default: '$'
    },
    sdtIn: {
      type: Object,
      default: null
    },
    uiColor: {
      type: String,
      default: 'white'
    },
    uiColorLightness: {
      type: Number,
      default: null
    },
    colorPicker: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    sdtIn () {
      this.execute(this.sdtIn)
    },
    dark () {
      const dark = this.dark
      const defaultColors = this.defaultColors
      this.$nextTick(() => {
        this.setColors()
        this.history.forEach(item => {
          const color = item.color
          dark ? item.color = color === defaultColors[1] ? defaultColors[0] : color : item.color = color === defaultColors[0] ? defaultColors[1] : color
        })
      })
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.setColors()
    },
    consoleReset () {
      this.console = {
        command: ''
      }
    },
    onKeyUp ($event) {
      let command
      const history = this.history
      const key = $event.key
      const keys = [
        'ArrowUp',
        'ArrowDown'
      ]
      if (keys.includes(key)) {
        switch (key) {
          case keys[0]:
            if (this.position >= 1) {
              this.position--
            }
            break
          case keys[1]:
            if (this.position <= history.length) {
              this.position++
            }
            break
        }
        command = {...history[this.position - 1]}
        if (command) {
          this.console = command
        } else {
          this.consoleReset()
        }
      }
    },
    clear () {
      this.consoleReset()
      this.history = []
      this.position = 0
    },
    setColors () {
      const defaultColors = this.defaultColors
      if (defaultColors.includes(this.internalColor)) {
        this.internalColor = this.dark ? defaultColors[0] : defaultColors[1]
      }
    },
    execute ($event) {
      const item = Object.assign({}, $event)
      const command = item.command.trim().replace(/\s/g, ' ')
      if (!item.command) {
        return
      }
      item.prefix = item.prefix || this.prefix
      item.color = item.color || this.internalColor
      item.bgColor = item.bgColor || this.textBgColor
      item.arguments = command.split(' ')
      item.command = command
      this.emit(item)
    },
    emit (command) {
      this.$emit('sdt-out', command)
      this.$nextTick(() => {
        this.history.push(command)
        this.console.command = ''
        this.position = this.history.length + 1
        this.$nextTick(() => {
          setTimeout(() => {
            const lastItem = this.$el.querySelector(`.${this.baseCss}-commands-list li:last-child`)
            if (lastItem) {
              lastItem.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              })
            }
          }, 100)
        })
      })
    }
  }
}
</script>
<style>
.bcq-terminal .bcq-text-field input
{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.bcq-terminal .bcq-text-field:not(.bcq-text-field-focus) .bcq-text-field-icon-wrapper .bcq-icon
{
  color: rgba(212, 212, 212, 1);
}

.bcq-terminal.bcq-terminal-dark .bcq-text-field:not(.bcq-text-field-focus) .bcq-text-field-icon-wrapper .bcq-icon
{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/terminal/terminal.vue